import React from "react";
import { ArrowLeft } from "lucide-react";

export function ScreenTitle({ hi, en, onBack }) {
  return (
    <div className="mb-4">
      {onBack && (
        <button onClick={onBack} data-testid="screen-back" className="mb-1 text-primary">
          <ArrowLeft className="h-6 w-6" />
        </button>
      )}
      <h1 className="font-display font-extrabold text-4xl text-blue-800 leading-tight text-center">{hi}</h1>
      {en && <p className="text-muted-foreground text-base mt-1 text-center font-display font-semibold">{en}</p>}
    </div>
  );
}
